import { useTranslation } from "react-i18next";
import Directions from "../../home/directions/Directions";

const BakalavrDirections = () => {
  const { t } = useTranslation();
  return <Directions titleOverride={t("bakalavr_yonalishlari")} endpoint={"/api/directions/bachelors/"} filterLevel={"bachelor"} />;
};

export default BakalavrDirections; 